/**
 * MedRecFilterBar - Fixed bottom bar for Med/Rec product filtering
 *
 * Only renders when store has both isMed AND isRec enabled.
 * Provides obvious toggle between Medical, Recreational, and All products.
 */

import { useEffect } from 'react';
import { useMedRecFilter, FILTER_OPTIONS } from '../../context/MedRecFilterContext.jsx';
import './MedRecFilterBar.scss';

// Cannabis icon (used for both med and rec)
import cannabisIcon from '../../assets/icons/reccannabis.png';

const MedRecFilterBar = () => {
  const { filter, setFilter, showFilter } = useMedRecFilter();

  // Add/remove body padding class when filter bar visibility changes
  useEffect(() => {
    if (showFilter) {
      document.body.classList.add('has-med-rec-filter');
    } else {
      document.body.classList.remove('has-med-rec-filter');
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('has-med-rec-filter');
    };
  }, [showFilter]);

  // Don't render if store doesn't support both med and rec
  if (!showFilter) {
    return null;
  }

  return (
    <div className="med-rec-filter-bar">
      <div className="med-rec-filter-bar__container">
        <span className="med-rec-filter-bar__label">
          Shop Products:
        </span>

        <div className="btn-group" role="group" aria-label="Product type filter">
          <button
            type="button"
            className={`btn ${filter === FILTER_OPTIONS.ALL ? 'btn-secondary' : 'btn-outline-secondary'}`}
            onClick={() => setFilter(FILTER_OPTIONS.ALL)}
            aria-pressed={filter === FILTER_OPTIONS.ALL}
          >
            All
          </button>

          <button
            type="button"
            className={`fw-bold btn ${filter === FILTER_OPTIONS.MED ? 'btn-success' : 'btn-outline-success'}`}
            onClick={() => setFilter(FILTER_OPTIONS.MED)}
            aria-pressed={filter === FILTER_OPTIONS.MED}
          >
           
            MEDICAL
          </button>

          <button
            type="button"
            className={`fw-bold btn ${filter === FILTER_OPTIONS.REC ? 'btn-purple' : 'btn-outline-purple'}`}
            onClick={() => setFilter(FILTER_OPTIONS.REC)}
            aria-pressed={filter === FILTER_OPTIONS.REC}
          >
           
            RECREATIONAL
          </button>
        </div>

        {filter !== FILTER_OPTIONS.ALL && (
          <span className="med-rec-filter-bar__status">
            Filtering: <strong>{filter === FILTER_OPTIONS.MED ? 'Medical' : 'Recreational'}</strong> cannabis products only
          </span>
        )}
      </div>
    </div>
  );
};

export default MedRecFilterBar;